// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview .thumbnail[data-v-9e356de0]{height:150px;overflow:hidden;border-top-left-radius:unset;border-top-right-radius:unset}.asset-preview .thumbnail img[data-v-9e356de0]{max-height:148px}.asset-preview .card-body .title[data-v-9e356de0]{height:38px;line-height:18px;font-weight:500;cursor:pointer;overflow-wrap:anywhere}", ""]);
// Exports
module.exports = exports;
